/**
 * Uppercases the first letter of each word, leaving the rest of each word as-is.
 * "home cleaning" -> "Home Cleaning", "carpet & upholstery" -> "Carpet & Upholstery".
 *
 * Note: does not lowercase the remaining characters, so already-uppercase letters
 * mid-word are preserved (e.g. "iPhone" stays "IPhone").
 */
export function toTitleCase(value: string): string {
  return value.replace(/\b\w/g, (char) => char.toUpperCase());
}
